import axios, { AxiosResponse } from "axios";
import { getAuth } from "src/modules/Auth/Core";
import { axiosInstance } from "src/services/axiosSetup";
import * as API from "src/services/consts/ProjectEnquiryRequest";


export function submitProjectEnquiryRequestApiRequest(data: any): Promise<AxiosResponse> {
    return axiosInstance.post(`${API.PROJECT_ENQ_REQ_BASE_URL}`, data).then((d: AxiosResponse) => d.data);
}


